import React, { useState, useEffect } from 'react';
import { DataGrid, useGridSlotComponentProps } from '@material-ui/data-grid';
import {
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from '@material-ui/core';
import { Typography } from '@material-ui/core';
import GridFilterDropdown from '../../../common/grid/filter-dropdown';
import { styles } from './styles';
import Pagination from '@material-ui/lab/Pagination';
import { makeStyles } from '@material-ui/core/styles';

export default function FilteredGrid(props) {
  const classes = styles();
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({});
  const [pageSize, setPageSize] = useState(10);

  const handleFilterUpdate = (filterName, value) => {
    const multiFilter = Array.isArray(value)
      ? value.map((val) => val.name)
      : value;
    setFilters({
      ...filters,
      [filterName]: multiFilter,
    });
  };

  const cellRenderer = (params) => {
    return params.value;
  };

  const filterRenderer = (filter) => {
    switch (filter.type) {
      case 'dropdown':
        return (
          <GridFilterDropdown
            iconType={filter.iconType}
            options={filter.options}
            onChange={(val) => handleFilterUpdate(filter.key, val)}
          />
        );
      default:
        return <></>;
    }
  };

  const headers = props.columns.map((col) => {
    return {
      field: col.name,
      width: col.width || 100,
      renderHeader: () => (
        <div className={classes.headerRoot}>
          <div>
            <Typography className={classes.columnHeaderTitle}>
              {col.headerLabel === undefined ? col.name : col.headerLabel}
            </Typography>
          </div>
          {/* <div className={classes.columnHeaderFilter}>
            {col.filter && filterRenderer(col.filter)}
          </div> */}
        </div>
      ),
      sortComparator: (v1, v2, param1, param2) => {
        // if (typeof (v1) === 'object') {
        //     return v1.props.actualValue - v2.props.actualValue
        // }

        // return v1 - v2
        return (
          param1.api.getCellValue(param1.id, v1.sortComparatorKey) -
          param2.api.getCellValue(param2.id, v2.sortComparatorKey)
        );
      },
      renderCell: cellRenderer,
      sortable: props.sortable,
    };
  });

  useEffect(() => {
    let rowsFiltered = props.rows;

    Object.keys(filters).forEach((filterName) => {
      if (filters[filterName] && filters[filterName].length !== 0) {
        let filterTypeCheck = new Date(filters[filterName]);
        rowsFiltered = rowsFiltered.filter((row) => {
          if (
            filterTypeCheck instanceof Date &&
            !isNaN(filterTypeCheck.valueOf()) &&
            row[filterName].substring(0, filters[filterName].length) ==
            filters[filterName]
          )
            return row[filterName];
          return filters[filterName].includes(row[filterName]);
        });
      }
    });

    setRows(rowsFiltered);
  }, [filters]);

  useEffect(() => {
    setRows(props.rows);
  }, [props.rows]);

  function CustomPagination() {
    const { state, apiRef } = useGridSlotComponentProps();
    const classes = useStyles();
    const handlePageSizeChange = (pSize) => {
      setPageSize(pSize);
      if (state.pagination.page > state.pagination.pageCount / (pSize / 10)) {
        apiRef.current.setPage(
          Math.ceil(state.pagination.pageCount / (pSize / 10)) - 1,
        );
      }
    };

    return (
      <Box sx={{ display: 'flex', width: '100%', margin: '1em auto' }}>
        <Box width={'12%'}>
          <FormControl fullWidth>
            <InputLabel>Page size</InputLabel>
            <Select
              value={pageSize}
              label="Page Size"
              onChange={(e) => handlePageSizeChange(e.target.value)}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={15}>15</MenuItem>
              <MenuItem value={20}>20</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Pagination
          className={classes.root}
          color="primary"
          count={Math.ceil(state.pagination.pageCount / (pageSize / 10))}
          page={Number(state.pagination.page + 1)}
          showFirstButton={true}
          showLastButton={true}
          siblingCount={3}
          boundaryCount={2}
          onChange={(event, value) => apiRef.current.setPage(value - 1)}
        />
      </Box>
    );
  }

  const useStyles = makeStyles({
    root: {
      display: 'flex',
      margin: 'auto',
    },
    overflow: {
      overflowY: 'scroll',
    },
  }, { name: 'filtered-grid-inner' });

  return (
    <div>
      <DataGrid
        columns={headers}
        hideFooterSelectedRowCount={true}
        rows={rows}
        pagination
        pageSize={pageSize}
        hideFooterRowCount={true}
        showCellRightBorder={false}
        disableColumnMenu={true}
        className={classes.DataGrid}
        components={{
          Pagination: CustomPagination,
        }}
      />
    </div>
  );
}
